import { useEffect } from "react";
import { useSelector } from "react-redux";

import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";
import { api } from "services";

import { FLOWABLE_DESIGN_URL } from "globals/constants";
import { notifyError } from "utils";

import { tenantSelectors } from "../store/selectors";

const injected = new Set();

const injectScript = async src => {
	return new Promise(resolve => {
		let script = document.createElement("script");
		script.src = `${FLOWABLE_DESIGN_URL}/${src}`;
		script.async = false;
		script.id = src;
		script.onload = () => {
			injected.add(src);
			resolve(script);
		};
		document.body.appendChild(script);
	});
};

export const useFormBuilderScripts = () => {
	const { simplifiedFormBuilderEnabled } = useSelector(tenantSelectors.tenant);

	const loadScripts = async () => {
		try {
			const res = await api.form.getScripts();

			return [
				...(res.independent ?? []).filter(url => !injected.has(url)),
				...(res.angular ?? []).filter(url => !injected.has(url)),
			];
		} catch (error) {
			notifyError("Can't load script.", error);
			console.error(error);
		}
	};

	//eslint-disable-next-line react-hooks/exhaustive-deps
	const bootstrap = async () => {
		const scripts = await loadScripts();

		if (isNonEmptyArray(scripts)) {
			await Promise.all(scripts.map(url => injectScript(url)));
			window.FLOWABLE_LOADED = true;
		}
	};

	useEffect(() => {
		if (!simplifiedFormBuilderEnabled) {
			bootstrap();
		}
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};

export default useFormBuilderScripts;
